import { Kbd } from "~/common/kbd";
import { formatOSHotKey } from "~/util/keyboard";

// What to press once a drop box is chosen for a screenshot on the clipboard.
export function PasteInstruction() {
  return (
    <span class="inline-flex flex-wrap items-center justify-center gap-1">
      Press <Kbd key={formatOSHotKey("Ctrl")} />
      <Kbd key="V" /> to paste your screenshot
    </span>
  );
}
